<script setup>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

const store = useStore();
const { t } = useI18n();

const inboxes = computed(() => store.getters['inboxes/getInboxes']);
const engines = computed(() => store.getters['teletelFlows/getEngines']);

onMounted(() => {
  store.dispatch('inboxes/get');
  store.dispatch('teletelFlows/fetchEngines');
});

const engineFor = inboxId =>
  engines.value.find(e => e.inbox_id === inboxId)?.engine ||
  'chatwoot_automation';

const setEngine = async (inboxId, event) => {
  try {
    await store.dispatch('teletelFlows/setEngine', {
      inboxId,
      engine: event.target.value,
    });
  } catch (error) {
    useAlert(
      error?.response?.data?.message ||
        error?.response?.data?.error ||
        t('TELETEL_FLOWS.ACTIONS.ERROR')
    );
  }
};
</script>

<template>
  <div class="p-4 mt-4 border rounded-xl border-n-weak">
    <h2 class="text-base font-medium text-n-slate-12">
      {{ t('TELETEL_FLOWS.ENGINES.TITLE') }}
    </h2>
    <p class="mb-3 text-sm text-n-slate-11">
      {{ t('TELETEL_FLOWS.ENGINES.NOTE') }}
    </p>
    <div class="flex flex-col gap-2">
      <div
        v-for="inbox in inboxes"
        :key="inbox.id"
        class="flex items-center justify-between gap-4"
      >
        <span class="text-sm text-n-slate-12">{{ inbox.name }}</span>
        <select
          class="w-64 mb-0 text-sm"
          :value="engineFor(inbox.id)"
          @change="setEngine(inbox.id, $event)"
        >
          <option value="chatwoot_automation">
            {{ t('TELETEL_FLOWS.ENGINES.chatwoot_automation') }}
          </option>
          <option value="teletel_flows">
            {{ t('TELETEL_FLOWS.ENGINES.teletel_flows') }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>
